import * as React from 'react'
import Svg, { Path } from 'react-native-svg'
export const HealthIcon = () => (
  <Svg width={40} height={41} viewBox='0 0 40 41' fill='none'>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 10C16.3431 10 15 11.3431 15 13V16H12C10.3431 16 9 17.3431 9 19V22C9 23.6569 10.3431 25 12 25H15V28C15 29.6569 16.3431 31 18 31H21C22.6569 31 24 29.6569 24 28V25H27C28.6569 25 30 23.6569 30 22V19C30 17.3431 28.6569 16 27 16H24V13C24 11.3431 22.6569 10 21 10H18ZM18 13H21V16.75C21 17.9926 22.0074 19 23.25 19H27V22H23.25C22.0074 22 21 23.0074 21 24.25V28H18V24.25C18 23.0074 16.9926 22 15.75 22H12V19H15.75C16.9926 19 18 17.9926 18 16.75V13Z'
      fill='#FE5000'
    />
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M31.5 4C33.9853 4 36 6.01472 36 8.5V32.5C36 34.9853 33.9853 37 31.5 37H7.5C5.01472 37 3 34.9853 3 32.5V8.5C3 6.01472 5.01472 4 7.5 4H31.5ZM31.5 7C32.3284 7 33 7.67158 33 8.5V32.5C33 33.3284 32.3284 34 31.5 34H7.5C6.67158 34 6 33.3284 6 32.5V8.5C6 7.67158 6.67158 7 7.5 7H31.5Z'
      fill='#FE5000'
    />
  </Svg>
)
